module.exports = __webpack_public_path__ + "img/fotografico.9eeceeaf.jpg";